/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class PreventCacheInterceptor {
        constructor(private cookiesService: CookiesService, private $sce: ng.ISCEService) {
        }
        
        public request = (config: any) => {
            if (config.url.indexOf('.html') > -1) {
                config.url = config.url + (config.url.indexOf('?') > -1 ? '&' : '?' ) + 't=#{VERSION_REPlACE}#';
            }
            else {
                config.url = this.urlInject(config.url);
            }
            
            return config;
        };


        private urlInject(url: string) {
            var companyNumber = this.cookiesService.readCookie('company');
            if (companyNumber == null) {
                companyNumber = 'null';
            }
            var qm = url.indexOf('?');
            if (qm > -1) {
                url = url.substring(0, qm) + '?' + url.substring(qm + 1).replace(/\?/g, '&');
            }
            return this.$sce.trustAsUrl(url.replace(/\{companyNumber\}/g, companyNumber));
        }
    }

    PreventCacheInterceptor.$inject = ['CookiesService', '$sce'];
    
    angular
        .module('eseebase')
        .service('PreventCacheInterceptor', PreventCacheInterceptor)
        .config(['$httpProvider', (_$httpProvider: ng.IHttpProvider) => {
            _$httpProvider.interceptors.push('PreventCacheInterceptor');
        }]);

}